import {
    FormSelectChoice,
    Country,
    getSafe,
} from '@sheerid/jslib';

export const shouldCollectAddressFields = (countryChoice: FormSelectChoice<Country, string>, countries: Country[]): boolean => {
    return (getSafe(() => countries.length === 1)
        && getSafe(() => countries[0]) === 'US')
        || getSafe(() => countryChoice.value === 'US')
        || getSafe(() => countryChoice.value === undefined);
};
